import { render, staticRenderFns } from "./NavigationBottomBar.vue?vue&type=template&id=241fde9e&lang=pug&"
import script from "./NavigationBottomBar.vue?vue&type=script&lang=js&"
export * from "./NavigationBottomBar.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBottomBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports